import { Injectable } from '@angular/core';

import { despachosRoute } from "../../shared/data.service";
import { licenciamentosRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import {newRoute, editRoute, configuracaoRoute} from "../../../shared/services/data.service";
import {obrigacoesRoute} from "../../obrigacoes/shared/data.service";

@Injectable()
export class LicenciamentoNavigationService {
    fatherRouter: string = despachosRoute;
    moduleRouter: string = licenciamentosRoute;

    constructor(private _authService: AuthService) {
    }

    goToList() {
        let router: string = this.fatherRouter + '/' + obrigacoesRoute + '/' + configuracaoRoute + '/' + this.moduleRouter;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = this.fatherRouter + '/' + obrigacoesRoute + '/' + configuracaoRoute + '/' + this.moduleRouter + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string =this.fatherRouter + '/' + obrigacoesRoute + '/' + configuracaoRoute + '/' + this.moduleRouter + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/shared/licenciamento-navigation.service.ts
 **/